import { render, staticRenderFns } from "./ActiveFolio.vue?vue&type=template&id=251eacd0&"
import script from "./ActiveFolio.vue?vue&type=script&lang=js&"
export * from "./ActiveFolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports